import diffusersIcon from '@/assets/frameworkLibraryIcons/diffusers.png';
import ggufIcon from '@/assets/frameworkLibraryIcons/gguf.png';
import llamafileIcon from '@/assets/frameworkLibraryIcons/llamafile.png';
import loraIcon from '@/assets/frameworkLibraryIcons/lora.png';
import mlxIcon from '@/assets/frameworkLibraryIcons/mlx.png';
import onnxIcon from '@/assets/frameworkLibraryIcons/onnx.png';
import openvinoIcon from '@/assets/frameworkLibraryIcons/openvino.png';
import pytorchIcon from '@/assets/frameworkLibraryIcons/pytorch.png';
import safetensorsIcon from '@/assets/frameworkLibraryIcons/safetensors.png';
import sentenceTransformersIcon from '@/assets/frameworkLibraryIcons/sentence-transformers.png';
import tensorflowIcon from '@/assets/frameworkLibraryIcons/tensorflow.png';
import transformerIcon from '@/assets/frameworkLibraryIcons/transformer.png';
import xinferenceIcon from '@/assets/frameworkLibraryIcons/xinference.png';

/** ModelScope 模型库「框架」筛选项。 */
export interface FrameworkLibraryOption {
  value: string;
  label: string;
  icon: string;
}

/**
 * ModelScope 模型库「框架」标签，顺序与 https://modelscope.cn/models?tabKey=libraries 一致。
 * value 与 ModelScope API `libraries` / `filter.library` 字段对齐。
 */
export const FRAMEWORK_LIBRARY_OPTIONS: FrameworkLibraryOption[] = [
  { value: 'gguf', label: 'GGUF', icon: ggufIcon },
  { value: 'diffusers', label: 'Diffusers', icon: diffusersIcon },
  { value: 'lora', label: 'LoRA', icon: loraIcon },
  { value: 'llamafile', label: 'Llamafile', icon: llamafileIcon },
  { value: 'onnx', label: 'ONNX', icon: onnxIcon },
  { value: 'pytorch', label: 'PyTorch', icon: pytorchIcon },
  { value: 'safetensors', label: 'Safetensors', icon: safetensorsIcon },
  { value: 'tensorflow', label: 'TensorFlow', icon: tensorflowIcon },
  { value: 'transformer', label: 'Transformers', icon: transformerIcon },
  { value: 'xinference', label: 'Xinference', icon: xinferenceIcon },
  { value: 'mlx', label: 'MLX', icon: mlxIcon },
  { value: 'openvino', label: 'OpenVINO', icon: openvinoIcon },
  { value: 'sentence-transformers', label: 'sentence-transformers', icon: sentenceTransformersIcon },
];

/** 按 value 索引框架选项，便于回显与展示。 */
export function getFrameworkLibraryOptionMap(): Map<string, FrameworkLibraryOption> {
  return new Map(FRAMEWORK_LIBRARY_OPTIONS.map((option) => [option.value, option]));
}
